import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BatchService {
	private _batchSearchCriteria: any;
	private _selectedBatch: any;

	constructor() { }

	set batchSearchCriteria(value: any) {
		this._batchSearchCriteria = value;
	}

	get batchSearchCriteria(): any {
		return this._batchSearchCriteria;
	}

	set selectedBatch(value: any) {
		this._selectedBatch = value;
	}
	get selectedBatch(): any {
		return this._selectedBatch;
	}


}
